import { render } from "./FavoriteToggler.vue?vue&type=template&id=cda56ed6&scoped=true&ts=true"
import script from "./FavoriteToggler.vue?vue&type=script&lang=ts"
export * from "./FavoriteToggler.vue?vue&type=script&lang=ts"

import "./FavoriteToggler.vue?vue&type=style&index=0&id=cda56ed6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cda56ed6"]])

export default __exports__